import { ReactNode } from 'react';

interface Props {
  caption?: string;
  isChecked?: boolean;
  handleCheckboxChange?: ((checked: boolean) => void) | null;
  className?: string;
  children?: ReactNode;
}

const InfoBlockCheckBox = ({ caption = '', isChecked = false, handleCheckboxChange = null, className = '', children = null }: Props) => {
  return (
    <div className={`py-3 ${className}`}>
      <p className="text-uppercase fs-7 text-gray-900 mb-1">{caption}</p>
      {children || <input className="fs-3" type="checkbox" checked={isChecked} onChange={(e) => handleCheckboxChange?.(e.target.checked)} disabled />}
    </div>
  );
};

export default InfoBlockCheckBox;
